/* Shon Shon theme scripts. No dependencies. */
(function () {
  'use strict';
  var S = window.ShonShon || { routes: {}, strings: {} };
  var root = (S.routes.root || '/').replace(/\/?$/, '/');

  function money(cents) {
    var fmt = S.moneyFormat || '₪{{amount}}';
    var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
    var noDec = Math.round(cents / 100).toString();
    return fmt.replace(/\{\{\s*amount_no_decimals[^}]*\}\}/, noDec).replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }

  function toast(text) {
    if (text === S.strings.added && window.ShonShonCart && window.ShonShonCart.open()) return;
    var el = document.createElement('div');
    el.className = 'toast';
    el.setAttribute('role', 'status');
    el.textContent = text + ' ';
    var a = document.createElement('a');
    a.href = S.routes.cart || '/cart';
    a.textContent = S.strings.viewCart || 'Cart';
    a.style.whiteSpace = 'nowrap';
    el.appendChild(a);
    document.querySelectorAll('.toast').forEach(function (t) { t.remove(); });
    document.body.appendChild(el);
    setTimeout(function () { el.remove(); }, 4000);
  }

  function updateCartCount() {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      }).catch(function () {});
  }

  function addItems(items) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || e.message || 'Error'); });
      return r.json();
    }).then(function (res) { updateCartCount(); return res; });
  }

  /* Mobile menu */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-menu-toggle]');
    if (t) {
      var header = t.closest('.site-header');
      var open = header.classList.toggle('is-open');
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  });
  /* Close mega menus when clicking outside */
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.nav details[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  /* Language selector auto-submit */
  document.querySelectorAll('[data-lang-select]').forEach(function (sel) {
    sel.addEventListener('change', function () { sel.form.submit(); });
  });

  /* Collection: sort select auto-submit */
  document.querySelectorAll('[data-autosubmit]').forEach(function (el) {
    el.addEventListener('change', function () { el.form.submit(); });
  });

  /* Quantity buttons */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    var v = parseInt(input.value, 10) || 1;
    v = b.getAttribute('data-qty') === '+' ? v + 1 : Math.max(parseInt(input.min || '0', 10), v - 1);
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Product form (product page + quick view) */
  function initProductForm(form) {
    var dataEl = form.querySelector('script[type="application/json"][data-product]');
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var idInput = form.querySelector('input[name="id"]');
    var addBtn = form.querySelector('[data-add]');
    var buyRow = form.querySelector('[data-buy-row]');
    var notifyBox = form.parentElement.querySelector('[data-notify-box]');
    var priceEl = form.closest('[data-product-root]') ? form.closest('[data-product-root]').querySelector('[data-price]') : null;
    var needsChoice = form.hasAttribute('data-require-choice');
    var chosen = !needsChoice;

    function selectedOptions() {
      return product.options.map(function (_, i) {
        var checked = form.querySelector('input[data-option-index="' + i + '"]:checked');
        return checked ? checked.value : null;
      });
    }
    function findVariant(opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return opts[i] === null || o === opts[i]; });
      });
    }
    function markAvailability(opts) {
      form.querySelectorAll('input[data-option-index]').forEach(function (input) {
        var i = parseInt(input.getAttribute('data-option-index'), 10);
        var test = opts.slice(); test[i] = input.value;
        var v = product.variants.find(function (vv) { return vv.options.every(function (o, j) { return test[j] === null || o === test[j]; }); });
        var label = form.querySelector('label[for="' + input.id + '"]');
        if (label) label.classList.toggle('is-unavailable', !v || !v.available);
      });
    }
    function render() {
      var opts = selectedOptions();
      markAvailability(opts);
      var complete = opts.every(function (o) { return o !== null; });
      var v = complete ? findVariant(opts) : null;
      if (v) {
        idInput.value = v.id;
        if (priceEl) {
          priceEl.innerHTML = (v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s> ' : '') + '<span class="price__now">' + money(v.price) + '</span>';
          priceEl.classList.toggle('price--sale', v.compare_at_price > v.price);
        }
        if (form.closest('[data-product-page]') && window.history.replaceState) {
          var url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url.toString());
        }
      }
      var ready = chosen && v && v.available;
      var soldOut = chosen && v && !v.available;
      form.__incomplete = !complete;
      if (complete) form.querySelectorAll('.option--need').forEach(function (f) { f.classList.remove('option--need'); });
      if (addBtn) {
        addBtn.disabled = complete && !ready;
        addBtn.textContent = ready ? S.strings.add : (soldOut ? S.strings.soldOut : S.strings.choose);
      }
      if (notifyBox) {
        notifyBox.hidden = !soldOut;
        var vf = notifyBox.querySelector('[data-notify-variant]');
        if (vf && v) vf.value = product.title + ' – ' + v.title;
      }
      if (buyRow) buyRow.hidden = !!soldOut;
      form.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v }, bubbles: true }));
    }
    form.addEventListener('change', function (e) {
      if (e.target.matches('input[data-option-index]')) { chosen = true; render(); }
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (form.__incomplete) {
        var missing = Array.prototype.find.call(form.querySelectorAll('fieldset.option'), function (fs) { return !fs.querySelector('input:checked'); });
        if (missing) {
          missing.classList.remove('option--need'); void missing.offsetWidth; missing.classList.add('option--need');
          missing.scrollIntoView({ behavior: 'smooth', block: 'center' });
          var first = missing.querySelector('input'); if (first) first.focus({ preventScroll: true });
        }
        return;
      }
      var qty = form.querySelector('input[name="quantity"]');
      var props = {};
      form.querySelectorAll('[name^="properties["]').forEach(function (p) {
        if ((p.type === 'checkbox' && !p.checked) || !p.value) return;
        props[p.name.slice(11, -1)] = p.value;
      });
      /* Gift card: send to recipient only when an email was entered */
      if ('__shopify_send_gift_card_to_recipient' in props && !props['Recipient email']) {
        ['__shopify_send_gift_card_to_recipient', 'Recipient name', 'Send on'].forEach(function (k) { delete props[k]; });
        if (props['_from'] && props.Message) props.Message = props.Message + ' — ' + props['_from'];
      }
      if (props['Send on'] && !/^\d{4}-\d{2}-\d{2}$/.test(props['Send on'])) delete props['Send on'];
      addBtn.disabled = true;
      addItems([{ id: parseInt(idInput.value, 10), quantity: qty ? parseInt(qty.value, 10) || 1 : 1, properties: props }])
        .then(function () {
          addBtn.textContent = S.strings.added;
          toast(S.strings.added);
          setTimeout(render, 1600);
          var dialog = form.closest('dialog'); if (dialog) dialog.close();
        })
        .catch(function (err) { addBtn.disabled = false; toast(err.message); });
    });
    render();
  }
  document.querySelectorAll('form[data-product-form]').forEach(initProductForm);

  /* Product gallery thumbs */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-thumb]');
    if (!t) return;
    var gallery = t.closest('[data-gallery]');
    var main = gallery.querySelector('[data-main-image]');
    main.src = t.getAttribute('data-src');
    main.srcset = t.getAttribute('data-srcset') || '';
    main.alt = t.getAttribute('data-alt') || '';
    gallery.querySelectorAll('[data-thumb]').forEach(function (b) { b.setAttribute('aria-current', b === t ? 'true' : 'false'); });
  });
  /* Switch main image when variant has its own image */
  document.addEventListener('variant:change', function (e) {
    var v = e.detail.variant;
    if (!v || !v.featured_media) return;
    var root = e.target.closest('[data-product-root]');
    var thumb = root && root.querySelector('[data-thumb][data-media-id="' + v.featured_media.id + '"]');
    if (thumb) thumb.click();
  });

  /* Quick view */
  var qv = document.getElementById('QuickView');
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-quick-view]');
    if (!b || !qv) return;
    e.preventDefault();
    var url = b.getAttribute('data-quick-view');
    var body = qv.querySelector('[data-qv-body]');
    body.innerHTML = '<p style="padding:40px">…</p>';
    if (typeof qv.showModal === 'function') qv.showModal();
    fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=quick-view-content')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var content = doc.querySelector('[data-qv-content]');
        body.innerHTML = content ? content.innerHTML : '';
        var form = body.querySelector('form[data-product-form]');
        if (form) initProductForm(form);
      }).catch(function () { window.location.href = url; });
  });
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-close-dialog]');
    if (c) c.closest('dialog').close();
  });
  document.querySelectorAll('dialog').forEach(function (d) {
    d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
  });

  /* Notify-me modal (from collection cards) */
  var nm = document.getElementById('NotifyModal');
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-notify]');
    if (!b || !nm) return;
    e.preventDefault();
    nm.querySelector('[data-notify-name]').textContent = b.getAttribute('data-notify');
    nm.querySelector('[data-notify-variant]').value = b.getAttribute('data-notify');
    if (typeof nm.showModal === 'function') nm.showModal();
  });

  /* Single-variant quick add from product cards */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    btn.disabled = true;
    addItems([{ id: parseInt(form.querySelector('input[name="id"]').value, 10), quantity: 1 }])
      .then(function () { btn.textContent = S.strings.added; toast(S.strings.added); setTimeout(function () { btn.disabled = false; btn.textContent = S.strings.add; }, 1800); })
      .catch(function (err) { btn.disabled = false; toast(err.message); });
  });

  /* Shop the look: add all */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-add-look]');
    if (!b) return;
    var ids = JSON.parse(b.getAttribute('data-add-look') || '[]').filter(Boolean);
    if (!ids.length) return;
    b.disabled = true;
    addItems(ids.map(function (id) { return { id: id, quantity: 1 }; }))
      .then(function () { b.textContent = S.strings.added; toast(S.strings.added); })
      .catch(function (err) { b.disabled = false; toast(err.message); });
  });

  /* Cart: gift toggle shows/hides gift fields */
  document.querySelectorAll('[data-gift-toggle]').forEach(function (cb) {
    var box = document.querySelector('[data-gift-fields]');
    function sync() { if (box) box.hidden = !cb.checked; }
    cb.addEventListener('change', sync); sync();
  });
  /* Cart: qty change auto-submit */
  document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
    var timer;
    input.addEventListener('change', function () { clearTimeout(timer); timer = setTimeout(function () { input.form.submit(); }, 500); });
  });

  /* Character counters */
  document.querySelectorAll('[data-count-for]').forEach(function (out) {
    var input = document.getElementById(out.getAttribute('data-count-for'));
    if (!input) return;
    function sync() { out.textContent = input.value.length + '/' + (input.maxLength > 0 ? input.maxLength : ''); }
    input.addEventListener('input', sync); sync();
  });

  /* Gift card live preview */
  document.querySelectorAll('[data-gc-form]').forEach(function (form) {
    var rootEl = form.closest('[data-product-root]');
    function text(sel, val) { var el = rootEl.querySelector(sel); if (el) el.textContent = val; }
    form.addEventListener('input', function () {
      var to = form.querySelector('[data-gc-to]'); var from = form.querySelector('[data-gc-from]'); var msg = form.querySelector('[data-gc-msg]');
      if (to) text('[data-gc-to-preview]', to.value ? to.value : rootEl.getAttribute('data-gc-to-default'));
      if (from) text('[data-gc-from-preview]', from.value ? from.value : rootEl.getAttribute('data-gc-from-default'));
      if (msg) text('[data-gc-msg-preview]', msg.value || rootEl.getAttribute('data-gc-msg-default'));
    });
    form.addEventListener('variant:change', function (e) {
      if (e.detail.variant) text('[data-gc-amount]', money(e.detail.variant.price));
    });
  });

  /* Hero video sound toggle */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-hero-sound]');
    if (!b) return;
    var v = b.parentElement.querySelector('video');
    if (!v) return;
    v.muted = !v.muted;
    if (!v.muted) v.play();
    b.textContent = v.muted ? '🔇' : '🔊';
    b.setAttribute('aria-pressed', v.muted ? 'false' : 'true');
  });

  /* Size finder: height/weight -> size, auto-select matching option */
  var SIZE_TABLE = [
    { key: '0-3', h: 62, w: 6 }, { key: '3-6', h: 68, w: 7.5 }, { key: '6-9', h: 74, w: 9 },
    { key: '9-12', h: 80, w: 10.5 }, { key: '12-18', h: 86, w: 12 }, { key: '18-24', h: 92, w: 13.5 }, { key: '2-3', h: 999, w: 999 }
  ];
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-sf-go]');
    if (!b) return;
    var box = b.closest('[data-size-finder]');
    var h = parseFloat(box.querySelector('[data-sf-height]').value);
    var w = parseFloat(box.querySelector('[data-sf-weight]').value);
    var out = box.querySelector('[data-sf-result]');
    if (!(h >= 40 && h <= 120)) h = NaN;
    if (!(w >= 1.5 && w <= 25)) w = NaN;
    if (!h && !w) { out.textContent = out.getAttribute('data-missing'); return; }
    var idx = SIZE_TABLE.findIndex(function (r) { return (!h || h <= r.h) && (!w || w <= r.w); });
    if (idx < 0) idx = SIZE_TABLE.length - 1;
    var root = box.closest('[data-product-root]') || document;
    var keyOf = function (r) { return r.value.replace(/[\u2013\u2014]/g, '-').replace(/[^0-9-]/g, ''); };
    var radios = Array.prototype.filter.call(root.querySelectorAll('input[data-option-index]'), function (r) {
      return SIZE_TABLE.some(function (s) { return s.key === keyOf(r); });
    });
    if (!radios.length) { out.textContent = out.getAttribute('data-template').replace('{size}', SIZE_TABLE[idx].key); return; }
    /* exact size, otherwise the nearest size this item comes in (prefer the next size up) */
    var best = null, bestDist = 99;
    radios.forEach(function (r) {
      var si = SIZE_TABLE.findIndex(function (s) { return s.key === keyOf(r); });
      var dist = si >= idx ? (si - idx) : (idx - si) + 0.5;
      var label = root.querySelector('label[for="' + r.id + '"]');
      if (label && label.classList.contains('is-unavailable')) dist += 0.25;
      if (dist < bestDist) { bestDist = dist; best = r; }
    });
    best.checked = true; best.dispatchEvent(new Event('change', { bubbles: true }));
    var msg = out.getAttribute('data-template').replace('{size}', best.value);
    if (bestDist >= 1) msg += ' (' + (out.getAttribute('data-nearest') || '') + ')';
    out.textContent = msg.replace(' ()', '');
  });



  /* Sticky add-to-cart (mobile product page) */
  (function () {
    var bar = document.querySelector('[data-sticky-atc]');
    var form = document.querySelector('[data-product-page] form[data-product-form]');
    if (!bar || !form || !('IntersectionObserver' in window)) return;
    var mainBtn = form.querySelector('[data-add]');
    var btn = bar.querySelector('[data-sticky-add]');
    var priceOut = bar.querySelector('[data-sticky-price]');
    var mainPrice = document.querySelector('[data-product-page] [data-price]');
    function sync() {
      btn.textContent = mainBtn.textContent;
      btn.disabled = mainBtn.disabled;
      if (mainPrice && priceOut) priceOut.innerHTML = mainPrice.innerHTML;
    }
    function show(on) {
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      btn.tabIndex = on ? 0 : -1;
      document.body.classList.toggle('has-sticky-atc', on);
    }
    new MutationObserver(sync).observe(mainBtn, { childList: true, characterData: true, subtree: true, attributes: true });
    form.addEventListener('variant:change', function () { setTimeout(sync, 0); });
    var target = form.querySelector('[data-buy-row]') || form;
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      show(!e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(target);
    btn.addEventListener('click', function () {
      if (form.__incomplete) { form.dispatchEvent(new Event('submit', { cancelable: true })); return; }
      if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
    });
    sync();
  })();



  /* Cart drawer */
  (function () {
    var wrap = document.querySelector('[data-cd]');
    if (!wrap) return;
    var panel = wrap.querySelector('[data-cd-panel]');
    var lastFocus = null, busy = false;
    function render() {
      return fetch(root + '?sections=cart-drawer', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (!data || !data['cart-drawer']) throw new Error('no section');
          panel.innerHTML = data['cart-drawer'];
          updateCartCount();
          upsell();
        });
    }
    function show() {
      lastFocus = document.activeElement;
      wrap.hidden = false;
      requestAnimationFrame(function () { wrap.classList.add('is-open'); });
      document.documentElement.classList.add('cd-lock');
      setTimeout(function () { var c = panel.querySelector('[data-cd-close]'); (c || panel).focus(); }, 60);
    }
    function hide() {
      wrap.classList.remove('is-open');
      document.documentElement.classList.remove('cd-lock');
      setTimeout(function () { wrap.hidden = true; }, 260);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function open() {
      render().then(show).catch(function () { window.location.href = S.routes.cart || '/cart'; });
      return true;
    }
    function upsell() {
      var box = panel.querySelector('[data-cd-upsell]');
      if (!box || !box.getAttribute('data-product-id')) return;
      var pid = box.getAttribute('data-product-id');
      var inCart = (box.getAttribute('data-in-cart') || '').split(',');
      var list = box.querySelector('[data-cd-upsell-list]');
      function get(intent) { return fetch(root + 'recommendations/products.json?product_id=' + pid + '&limit=6&intent=' + intent).then(function (r) { return r.ok ? r.json() : { products: [] }; }).catch(function () { return { products: [] }; }); }
      get('complementary').then(function (d) { return (d.products && d.products.length) ? d : get('related'); }).then(function (d) {
        var items = (d.products || []).filter(function (p) { return p.available && inCart.indexOf(String(p.id)) === -1; }).slice(0, 2);
        if (!items.length) return;
        list.innerHTML = '';
        items.forEach(function (p) {
          var row = document.createElement('div'); row.className = 'cd__up';
          var img = p.featured_image ? '<img src="' + p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" loading="lazy">' : '';
          var single = p.variants.length === 1;
          row.innerHTML = '<a class="cd__up-media" href="' + p.url + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
            '<div class="cd__up-info"><a href="' + p.url + '"></a><span class="price">' + money(p.price) + '</span></div>';
          row.querySelector('.cd__up-info a').textContent = p.title;
          var btn;
          if (single) {
            btn = document.createElement('button'); btn.type = 'button'; btn.className = 'btn btn--sm'; btn.textContent = S.strings.drawerAdd || '+';
            btn.addEventListener('click', function () {
              btn.disabled = true;
              fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: p.variants[0].id, quantity: 1 }] }) })
                .then(function (r) { if (!r.ok) throw 0; return render(); }).catch(function () { btn.disabled = false; });
            });
          } else {
            btn = document.createElement('a'); btn.className = 'btn btn--sm btn--outline'; btn.href = p.url; btn.textContent = S.strings.drawerChoose || '→';
          }
          row.appendChild(btn); list.appendChild(row);
        });
        box.hidden = false;
      });
    }
    wrap.addEventListener('click', function (e) {
      if (e.target.closest('[data-cd-close]')) { hide(); return; }
      var q = e.target.closest('[data-cd-qty]');
      if (q && !busy) {
        busy = true; panel.classList.add('is-busy');
        fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: parseInt(q.getAttribute('data-cd-qty'), 10), quantity: Math.max(0, parseInt(q.getAttribute('data-q'), 10)) }) })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || ''); }); })
          .catch(function (err) { if (err && err.message) toast(err.message); })
          .then(render).catch(function () {})
          .then(function () { busy = false; panel.classList.remove('is-busy'); });
      }
    });
    document.addEventListener('keydown', function (e) {
      if (wrap.hidden) return;
      if (e.key === 'Escape') hide();
      if (e.key === 'Tab') {
        var f = panel.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href]');
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
      var cartPath = (S.routes.cart || '/cart');
      if (a.closest('[data-cd]')) return;
      if (a.getAttribute('href') === cartPath && a.closest('.site-header')) { e.preventDefault(); open(); }
    });
    window.ShonShonCart = { open: open, close: hide, refresh: render };
  })();

  /* Help bot: guided answers, then WhatsApp / email handoff with context */
  (function () {
    var box = document.querySelector('[data-hb]');
    if (!box) return;
    var cfg; try { cfg = JSON.parse(box.querySelector('[data-hb-config]').textContent); } catch (e) { return; }
    var T = cfg.t, U = cfg.urls;
    var panel = box.querySelector('.hb__panel'), toggle = box.querySelector('[data-hb-toggle]');
    var log = box.querySelector('[data-hb-log]'), actions = box.querySelector('[data-hb-actions]');
    var ctx = { topic: '', order: '' };
    var started = false;

    function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
    function scroll() { log.scrollTop = log.scrollHeight; }
    function say(text, who) {
      var m = el('div', 'hb__msg hb__msg--' + (who || 'bot'), text);
      log.appendChild(m); scroll(); return m;
    }
    function typing(cb) {
      var d = el('div', 'hb__msg hb__msg--bot hb__typing'); d.innerHTML = '<span></span><span></span><span></span>';
      d.setAttribute('aria-hidden', 'true');
      log.appendChild(d); scroll();
      setTimeout(function () { d.remove(); cb(); }, document.documentElement.classList.contains('a11y-still') ? 0 : 450);
    }
    function clearActions() { actions.innerHTML = ''; }
    function chip(label, fn, primary) {
      var b = el('button', 'hb__chip' + (primary ? ' hb__chip--primary' : ''), label); b.type = 'button';
      b.addEventListener('click', fn); actions.appendChild(b); return b;
    }
    function link(label, href) {
      var a = el('a', 'hb__chip hb__chip--link', label); a.href = href; actions.appendChild(a); return a;
    }
    function menu() {
      clearActions();
      [['order', T.t_order], ['size', T.t_size], ['ship', T.t_ship], ['return', T.t_return], ['club', T.t_club], ['gift', T.t_gift]].forEach(function (x) {
        chip(x[1], function () { pick(x[0], x[1]); });
      });
      chip(T.t_human, function () { pick('human', T.t_human); }, true);
    }
    function after(extra) {
      clearActions();
      if (extra) extra();
      typing(function () {
        say(T.still);
        chip(T.yes, function () { say(T.yes, 'user'); clearActions(); typing(function () { say(T.thanks); chip(T.back, function () { menu(); }); }); });
        chip(T.no, function () { say(T.no, 'user'); human(); }, true);
        chip(T.back, function () { menu(); });
      });
    }
    function pick(key, label) {
      say(label, 'user'); ctx.topic = label; clearActions();
      typing(function () {
        if (key === 'order') {
          say(T.a_order); say(T.a_order_ask);
          var f = el('form', 'hb__form'); var i = el('input', 'hb__input'); i.type = 'text'; i.inputMode = 'numeric'; i.placeholder = T.order_ph; i.setAttribute('aria-label', T.order_ph); i.maxLength = 20;
          var go = el('button', 'hb__send', '→'); go.type = 'submit'; go.setAttribute('aria-label', T.send_wa);
          f.appendChild(i); f.appendChild(go); actions.appendChild(f);
          f.addEventListener('submit', function (e) { e.preventDefault(); var v = i.value.replace(/[^0-9#A-Za-z-]/g, '').slice(0, 20); if (v) { ctx.order = v; say(v, 'user'); human(); } });
          chip(T.back, function () { menu(); });
          setTimeout(function () { i.focus(); }, 50);
          return;
        }
        if (key === 'size') {
          say(T.a_size);
          return after(function () {
            if (document.querySelector('[data-size-finder]')) chip(T.b_finder, function () { close(); var f = document.querySelector('[data-size-finder]'); f.scrollIntoView({ behavior: 'smooth', block: 'center' }); var inp = f.querySelector('input'); if (inp) setTimeout(function () { inp.focus({ preventScroll: true }); }, 400); });
            link(T.b_size_page, U.size);
          });
        }
        if (key === 'ship') { say(T.a_ship); return after(function () { link(T.b_ship_page, U.ship); }); }
        if (key === 'return') { say(T.a_return); return after(function () { link(T.b_return_page, U['return']); }); }
        if (key === 'club') {
          say(T.a_club);
          return after(function () {
            link(T.b_club, U.club);
            var c = chip(T.b_copy + ' WELCOME10', function () {}); c.setAttribute('data-copy', 'WELCOME10'); c.setAttribute('data-copied', '✓');
          });
        }
        if (key === 'gift') { say(T.a_gift); return after(function () { if (U.giftcard) link(T.b_giftcard, U.giftcard); }); }
        if (key === 'human') { human(true); }
      });
    }
    function human(skipTyping) {
      clearActions();
      var run = function () {
        say(T.human_intro);
        var f = el('form', 'hb__form hb__form--col');
        var n = el('input', 'hb__input'); n.type = 'text'; n.placeholder = T.name_ph; n.setAttribute('aria-label', T.name_ph); n.maxLength = 40; n.autocomplete = 'given-name';
        var q = el('textarea', 'hb__input'); q.rows = 2; q.placeholder = T.human_ph; q.setAttribute('aria-label', T.human_ph); q.maxLength = 400;
        var b = el('button', 'hb__chip hb__chip--primary hb__chip--wa', T.send_wa); b.type = 'submit';
        f.appendChild(n); f.appendChild(q); f.appendChild(b); actions.appendChild(f);
        function message() {
          var lines = [T.wa_hello];
          if (n.value.trim()) lines.push(T.wa_name + ': ' + n.value.trim());
          if (ctx.topic && ctx.topic !== T.t_human) lines.push(T.wa_topic + ': ' + ctx.topic);
          if (ctx.order) lines.push(T.wa_order + ': ' + ctx.order);
          if (q.value.trim()) lines.push(T.wa_q + ': ' + q.value.trim());
          lines.push(T.wa_page + ': ' + location.href.split('?')[0]);
          return lines.join('\n');
        }
        f.addEventListener('submit', function (e) {
          e.preventDefault();
          if (cfg.wa) window.open('https://wa.me/' + cfg.wa + '?text=' + encodeURIComponent(message()), '_blank', 'noopener');
          else if (cfg.email) location.href = 'mailto:' + cfg.email + '?body=' + encodeURIComponent(message());
        });
        if (cfg.email && cfg.wa) {
          var m = el('a', 'hb__mail', T.send_mail); m.href = '#';
          m.addEventListener('click', function (e) { e.preventDefault(); location.href = 'mailto:' + cfg.email + '?subject=' + encodeURIComponent('Shon Shon') + '&body=' + encodeURIComponent(message()); });
          actions.appendChild(m);
        }
        chip(T.back, function () { menu(); });
        setTimeout(function () { (ctx.order ? q : n).focus(); }, 50);
      };
      skipTyping ? run() : typing(run);
    }
    function open() {
      panel.hidden = false; toggle.setAttribute('aria-expanded', 'true'); box.classList.add('is-open');
      if (!started) { started = true; typing(function () { say(T.hello); menu(); }); }
      setTimeout(function () { var f = actions.querySelector('button, input'); if (f) f.focus(); }, 520);
    }
    function close() { panel.hidden = true; toggle.setAttribute('aria-expanded', 'false'); box.classList.remove('is-open'); }
    toggle.addEventListener('click', function () { panel.hidden ? open() : close(); });
    box.querySelector('[data-hb-close]').addEventListener('click', function () { close(); toggle.focus(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) { close(); toggle.focus(); } });
    window.ShonShonBot = { open: open, close: close };
  })();

  /* Accessibility toolbar */
  (function () {
    var box = document.querySelector('[data-a11y]');
    if (!box) return;
    var html = document.documentElement;
    var panel = box.querySelector('.a11y__panel');
    var toggle = box.querySelector('[data-a11y-toggle]');
    var KEY = 'shon-a11y';
    var state = { size: 0, opts: {} };
    try { state = JSON.parse(localStorage.getItem(KEY)) || state; } catch (e) {}
    state.opts = state.opts || {};
    function save() { try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {} }
    function apply() {
      var zoom = 1 + state.size * 0.1;
      html.style.setProperty('--a11y-zoom', zoom);
      var out = box.querySelector('[data-a11y-size-out]'); if (out) out.textContent = Math.round(zoom * 100) + '%';
      box.querySelectorAll('[data-a11y-opt]').forEach(function (b) {
        var k = b.getAttribute('data-a11y-opt'), on = !!state.opts[k];
        html.classList.toggle('a11y-' + k, on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      document.querySelectorAll('video[autoplay]').forEach(function (v) {
        if (state.opts.still) { v.pause(); } else if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      });
    }
    function open(o) {
      panel.hidden = !o; toggle.setAttribute('aria-expanded', o ? 'true' : 'false');
      if (o) { var f = panel.querySelector('button'); if (f) f.focus(); } else { toggle.focus(); }
    }
    toggle.addEventListener('click', function () { open(panel.hidden); });
    box.querySelector('[data-a11y-close]').addEventListener('click', function () { open(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) open(false); });
    document.addEventListener('click', function (e) { if (!panel.hidden && !box.contains(e.target)) { panel.hidden = true; toggle.setAttribute('aria-expanded', 'false'); } });
    box.addEventListener('click', function (e) {
      var s = e.target.closest('[data-a11y-size]');
      if (s) { state.size = Math.max(-1, Math.min(4, state.size + parseInt(s.getAttribute('data-a11y-size'), 10))); }
      var o = e.target.closest('[data-a11y-opt]');
      if (o) { var k = o.getAttribute('data-a11y-opt'); state.opts[k] = !state.opts[k]; }
      if (e.target.closest('[data-a11y-reset]')) { state = { size: 0, opts: {} }; }
      if (s || o || e.target.closest('[data-a11y-reset]')) { save(); apply(); }
    });
    apply();
  })();

  /* Copy buttons */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-copy]');
    if (!b) return;
    var val = b.getAttribute('data-copy');
    var done = function () { var t = b.textContent; b.textContent = b.getAttribute('data-copied') || '✓'; setTimeout(function () { b.textContent = t; }, 1500); };
    var fallback = function () {
      var ta = document.createElement('textarea'); ta.value = val; ta.setAttribute('readonly', '');
      ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0;font-size:16px'; document.body.appendChild(ta);
      ta.select(); ta.setSelectionRange(0, val.length);
      try { document.execCommand('copy'); done(); } catch (err) { window.prompt('', val); }
      ta.remove();
    };
    if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(val).then(done).catch(fallback); else fallback();
  });
})();
